import { render, staticRenderFns } from "./AvailableWorkspace.vue?vue&type=template&id=ad3cd832"
import script from "./AvailableWorkspace.vue?vue&type=script&lang=js"
export * from "./AvailableWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports